import { render, staticRenderFns } from "./TipoAlteracaoForm.vue?vue&type=template&id=213e55da"
import script from "./TipoAlteracaoForm.vue?vue&type=script&lang=js"
export * from "./TipoAlteracaoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports